/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import { NatalChart } from '../../entities';

export const updateNatalChart = createAction<NatalChart>('natalChart/UPDATE_NATAL_CHART');
